<template>
    <div class="row">
        <transition-group class="tabs" tag="ul" name="table-row">
            <li :key="1" @click="changeTable('contractor')" :class="`tab ${table == 'contractor' ? 'selected' : ''}`">
                <a style="cursor: pointer" class="indigo-text">Sou contratante</a>
            </li>
            <li :key="2" @click="changeTable('supplier')" :class="`tab ${table == 'supplier' ? 'selected' : ''}`">
                <a style="cursor: pointer" class="indigo-text">Sou fornecedor</a>
            </li>
        </transition-group>
    </div>
</template>

<script>
export default {
    name: 'HomeMenu',
    data: () => ({
        column: false,
        table: 'supplier', // contractor
        titles: ['Sou contratante', 'Sou fornecedor']
    }),
    methods: {
        changeTable(tab) {
            if (tab == 'contractor') {
                this.table = tab;
                this.$emit('table', false);
            } else {
                this.table = tab;
                this.$emit('table', true);
            }
        }
    }
};
</script>

<style scoped>
.selected {
    border-bottom: 2px solid;
    border-color: #3f51b5;
}
</style>
